<template>
  <div
    class="d-flex-column e_learning_card space-between align-start"
    role="button"
    @click="selectElearning"
    :class="[isSelected && 'selected']"
  >
    <div class="d-flex-row flex-2 space-between">
      <div class="d-flex-row justify-start flex-5 gap-5">
        <StopWatch />
        <h4 class="t-white font-family-2 medium-l">
          {{ $t("e_learning.start_in_10_minutes") }}
        </h4>
      </div>
      <div class="d-flex-row flex-5 justify-end">
        <RadioButton :checked="isSelected" />
      </div>
    </div>
    <img :src="image" alt="Game pack image" class="pack_image" />
    <div class="d-flex-column justify-end align-start gap-6 flex-5">
      <div class="d-flex-row flex-1 justify-start">
        <h4 class="t-white font-family-1 body-xxl">{{ title }}</h4>
        <Tooltip :text="description" style="margin-left: 10px">
          <PoiIcon />
        </Tooltip>
      </div>
      <p class="t-light font-family-2 regular-l" style="max-width: 25ch">
        {{ $t("e_learning.card_description") }}
      </p>

      <p class="t-blue bold-xl font-family-2" style="margin-top: 10px">
        ${{ price }}<span class="medium-l t-grey-dark"> /{{ span }} </span>
      </p>
    </div>
  </div>
</template>

<script>
import StopWatch from "../icons/StopWatch.vue";
import PoiIcon from "../icons/PoiIcon.vue";
import RadioButton from "../custom/RadioButton.vue";
import Tooltip from "../custom/Tooltip.vue";
export default {
  data() {
    return {};
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    price: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: 0,
    },
    slab: {
      default: 0,
    },
    onClick: {
      default: () => {},
    },
    data: {
      default: {},
    },
    tooltipText: {
      default: "",
    },
  },
  computed: {
    isSelected() {
      if (this.checkoutStore.getDetails?.elearningId) {
        return this.id === this.checkoutStore.getDetails?.elearningId;
      }
      if (this.checkoutStore.getDetails?.slab) {
        return this.slab === this.checkoutStore.getDetails?.slab;
      }
      return false;
    },
    span() {
      if (this.image.includes("vod-review.webp")) {
        return this.$t("e_learning.vod");
      }
      if (this.image.includes("play-and-learn.webp")) {
        return this.$t("e_learning.game");
      }
      return this.$t("e_learning.hour");
    },
    translationSpan() {
      if (this.image.includes("vod-review.webp")) {
        return "vod-review";
      }
      if (this.image.includes("play-and-learn.webp")) {
        return "play-and-learn";
      }
      return "coaching";
    },
  },
  components: {
    StopWatch,
    PoiIcon,
    RadioButton,
    Tooltip,
  },
  methods: {
    selectElearning() {
      this.checkoutStore.clearDetails();
      this.checkoutStore.setDetails({
        ...this.checkoutStore.getDetails,
        elearningId: this.id,
        elearningTitle: this.title,
        slab: this.slab,
      });
      this.onClick();
    },
  },

  setup() {
    const checkoutStore = useCheckoutStore();
    const { currentGameSlug } = useGameComposable();
    return { checkoutStore, currentGameSlug };
  },
};
</script>
